import { useEffect } from 'react';
import { atom, useAtom, SetStateAction } from 'jotai';

// @ts-ignore
type TUseIncomeReturn = [boolean, SetAtom<[SetStateAction<string>], void>];
export const IncomeAtom = atom<boolean>(false);

const useFirstIncome = (): TUseIncomeReturn => {
  const [firstIncome, setFirstIncome] = useAtom(IncomeAtom);

  useEffect(() => {
    let income = localStorage?.getItem('firstIncome') ?? '';
    setFirstIncome(!income);
  }, [setFirstIncome]);

  return [firstIncome, setFirstIncome];
};

export default useFirstIncome;
